import { h } from 'preact';

export default (props) => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M8.00008 8.66634C9.10465 8.66634 10.0001 7.77091 10.0001 6.66634C10.0001 5.56177 9.10465 4.66634 8.00008 4.66634C6.89551 4.66634 6.00008 5.56177 6.00008 6.66634C6.00008 7.77091 6.89551 8.66634 8.00008 8.66634Z" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M8.00008 14.6663C10.6667 11.9997 13.3334 9.61186 13.3334 6.66634C13.3334 3.72082 10.9456 1.33301 8.00008 1.33301C5.05456 1.33301 2.66675 3.72082 2.66675 6.66634C2.66675 9.61186 5.33341 11.9997 8.00008 14.6663Z" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);
